module.exports = __webpack_public_path__ + "2e1dcaa22a260e1da33b7ab16c13a109.svg";